import { render, staticRenderFns } from "./ClasificacionDocumentosPorNumeroDescargas.vue?vue&type=template&id=ac9e27ee&"
import script from "./ClasificacionDocumentosPorNumeroDescargas.vue?vue&type=script&lang=js&"
export * from "./ClasificacionDocumentosPorNumeroDescargas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports